import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../common-components/CommonStructured";
import {
  fetchRecurringSubscriptionsData,
  fetchRecurringSubscriptionStatsData,
} from "../../redux/plans-reducers/plansSlice";
import RecurringSubsListings from "./RecurringSubsListings";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import { getReplace1 } from "../common-data/Conversions";
import UTMParams from "../lead-management/raw-leads/UTMParams";
import CmnFilters from "../lead-management/common/CmnFilters";
import RecurringSubsStats from "./RecurringSubsStats";
import AddLeadForm from "../lead-management/AddLeadForm";
import LeadFollowupV1 from "../lead-management/followup/LeadFollowupV1";
import ViewDetails from "../odm/odm-details/ViewDetails";

const RecurringSubs = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { recurringSubscriptionLoading, recurringSubscriptionStatsLoading } =
    useSelector((state) => state.plans);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isMarketing && !isClusterManager
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    isActive: "",
    selAddNotAddToLead: "",
    selectedODMStatus: "",
    selectedLMSSorting: "",
    selectedDateAddedSorting: "",
    selLeadFrom: "",

    selUTMSource: "",
    selUTMMedium: "",
    selUTMContent: "",
    selUTMTerm: "",
    selUTMCampaign: "",

    leadAddDateFrom: "",
    leadAddDateTo: "",
    leadConvertedDateFrom: "",
    leadConvertedDateTo: "",

    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,

    gym_id: allFilters.selectedGym?.value || "",
    added_to_lead: allFilters.selAddNotAddToLead?.value || "",
    plan_status: allFilters.isActive?.value || "",
    is_payment_done: allFilters.selectedODMStatus?.value || "",
    lead_from: allFilters.selLeadFrom?.value || "",

    utm_source: allFilters.selUTMSource?.value || "",
    utm_medium: allFilters.selUTMMedium?.value || "",
    utm_content: allFilters.selUTMContent?.value || "",
    utm_term: allFilters.selUTMTerm?.value || "",
    utm_campaign: allFilters.selUTMCampaign?.value || "",

    start_date: allFilters.leadAddDateFrom || "",
    end_date: allFilters.leadAddDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    rowData: "",
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
  };

  function closeModal() {
    setModValues(iniModvalues);
  }

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getRecurringSubscriptionStats(filters) {
    const { page, limit, ...rest } = filters;

    dispatch(
      fetchRecurringSubscriptionStatsData({
        filters: rest,
        token: userInfoData?.token,
      })
    );
  }

  function getSubscriptions(filters) {
    dispatch(
      fetchRecurringSubscriptionsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getRecurringSubscriptionStats(filters);
  }, [
    filters.gym_id,
    filters.added_to_lead,
    filters.plan_status,
    filters.is_payment_done,
    filters.not_added_lms_sort,
    filters.date_added_sort,
    filters.training_gym_data,
    filters.utm_source,
    filters.utm_medium,
    filters.utm_content,
    filters.utm_term,
    filters.utm_campaign,
    filters.start_date,
    filters.end_date,
    filters.convert_start_date,
    filters.convert_end_date,
  ]);

  useEffect(() => {
    getSubscriptions(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,

      gym_id: allFilters.selectedGym?.value || "",
      plan_status: allFilters.isActive?.value || "",
      added_to_lead: allFilters.selAddNotAddToLead?.value || "",
      is_payment_done: allFilters.selectedODMStatus?.value || "",
      lead_from: allFilters.selLeadFrom?.value || "",

      utm_source: allFilters.selUTMSource?.value || "",
      utm_medium: allFilters.selUTMMedium?.value || "",
      utm_content: allFilters.selUTMContent?.value || "",
      utm_term: allFilters.selUTMTerm?.value || "",
      utm_campaign: allFilters.selUTMCampaign?.value || "",

      start_date: allFilters.leadAddDateFrom || "",
      end_date: allFilters.leadAddDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.isActive,
    allFilters.selAddNotAddToLead,
    allFilters.selectedODMStatus,
    allFilters.selUTMSource,
    allFilters.selUTMMedium,
    allFilters.selUTMContent,
    allFilters.selUTMTerm,
    allFilters.selUTMCampaign,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.selLeadFrom,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <HelmetWrapper title="WTF: Recurring Subscriptions">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={closeModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "UTM_parameters"
                ? "mod-width-50p"
                : modValues.modName === "view_details"
                ? "mod-width-50p"
                : modValues.modName === "add-to-lead"
                ? "p-0 mod-width-50p mod-height-95vh"
                : ""
            }`}
          >
            {modValues.modName === "add-to-lead" ? null : (
              <ModalHeadAndClose
                title={`${getReplace1(modValues.modName)}`}
                onClose={closeModal}
              />
            )}

            {modValues.modName === "UTM_parameters" ? (
              <UTMParams rowData={modValues.rowData} />
            ) : modValues.modName === "add-to-lead" ? (
              <AddLeadForm
                userInfoData={userInfoData}
                closeModal={closeModal}
                callFunction={() => {
                  getSubscriptions(filters);
                  getRecurringSubscriptionStats(filters);
                }}
                rowData={modValues.rowData}
                isRecurring999={true}
              />
            ) : modValues.modName === "follow-up" ? (
              <LeadFollowupV1
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                closeFollowupModal={closeModal}
                isAllLeadDetails={true}
                pageName="recurring-999"
                prevFilters={(({ limit, page, added_to_lead, ...rest }) =>
                  rest)(filters)}
              />
            ) : modValues.modName === "view_details" ? (
              <ViewDetails
                rowData={modValues.rowData}
                from={modValues.from}
                userInfoData={userInfoData}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Recurring Subscriptions"}
              isReload={() => {
                getSubscriptions(filters);
                getRecurringSubscriptionStats(filters);
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from={"recurring-999"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={
                recurringSubscriptionLoading ||
                recurringSubscriptionStatsLoading
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <RecurringSubsStats />
          </Col>
        </Row>

        <Row>
          <Col>
            <RecurringSubsListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default RecurringSubs;
